import { cn } from '../../utils/cn'

const dotClassName = 'absolute top-[41.25%] size-[16.25%] rounded-[50%] bg-current'

const DotDotLoader = ({ color }: { color?: string }) => {
  return (
    <div
      className="relative inline-block size-full text-white [transform:scale(0.9)_translateX(3%)]"
      style={color ? { color } : undefined}
    >
      <div className={cn(dotClassName, 'left-[10%] animate-dot-grow')} />
      <div className={cn(dotClassName, 'left-[10%] animate-dot-shift')} />
      <div className={cn(dotClassName, 'left-[40%] animate-dot-shift')} />
      <div className={cn(dotClassName, 'left-[70%] animate-dot-shrink')} />
    </div>
  )
}

export default DotDotLoader
